import { View, Text, ScrollView, Modal } from "react-native";
import React, { useEffect } from "react";
import ProfileBody from "./ProfileBody";
import Colours from "../../utils/Colours";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import { useNavigation } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import TopHeaderTables from "../myTables/TopHeaderTables";
import TopHeaderProfile from "./TopHeaderProfile";

const ProfileScreen = ({ hideProfileScreen }) => {
  const navigation = useNavigation();

  // useEffect(() => {
  //   // Hide tab bar when this screen is focused
  //   const parent = navigation.getParent(); // get TabNavigator
  //   parent?.setOptions({ tabBarStyle: { display: "none" } });

  //   // Restore tab bar when leaving the screen
  //   return () => parent?.setOptions({ tabBarStyle: undefined });
  // }, [navigation]);

  return (
    // <SafeAreaView style={{ backgroundColor: "white" }}>
    <SafeAreaView
      style={{
        flex: 1,
        backgroundColor: "white",
      }}
    >
      <TopHeaderProfile />
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: Colours.LIGHTEST,
        }}
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: 200,
          minHeight: "100%",
        }}
        showsVerticalScrollIndicator={false}
        nestedScrollEnabled={true}
        keyboardShouldPersistTaps="handled"
      >
        {/* <ScrollView
        contentContainerStyle={{
          flexGrow: 1,
          paddingBottom: 200,
          backgroundColor: Colours.LIGHTEST,
        }}
      > */}
        <ProfileBody />
      </ScrollView>
    </SafeAreaView>
  );
};

export default ProfileScreen;
